import { render } from "./NavBreadcrumbs.vue?vue&type=template&id=3c6bc31e&scoped=true"
import script from "./NavBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./NavBreadcrumbs.vue?vue&type=script&lang=js"

import "./NavBreadcrumbs.vue?vue&type=style&index=0&id=3c6bc31e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6bc31e"]])

export default __exports__